import { Dispatch } from 'redux';
import SignalConfigurationController from '../controllers/SignalConfigurationController';
import commonHandler from '../errorHandlers/common-handler';
import { Configuration, SignalEventsResponse } from '../model/SignalModel';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class SignalConfigurationCRUDActions extends CrudActionContainer {
  eventsRetrieved: string;
  resetStore: string;

  constructor() {
    super('SIGNAL_CONFIGURATION');
    this.eventsRetrieved = this.makeActionKey('EVENTS_RETRIEVED');
    this.resetStore = this.makeActionKey('RESET_STORE');
  }

  update(data: Partial<Configuration> & { id: number }) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.updateAction));
        const response = await SignalConfigurationController.update(data);
        dispatch(this.retrieved(response));
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  fetch(facebookPageId: number) {
    return async (dispatch: Dispatch<StoreState>): Promise<Configuration> => {
      try {
        const configuration = await SignalConfigurationController.fetch(
          facebookPageId,
        );
        dispatch(this.retrieved(configuration));
        return configuration;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }

  getEvents({
    facebookPageId,
    force = false,
    range,
  }: {
    facebookPageId: number;
    force?: boolean;
    range?: 'week' | 'month' | '3 months';
  }) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.eventsRetrieved));
      try {
        const response: SignalEventsResponse =
          await SignalConfigurationController.getEvents({
            facebookPageId,
            force,
            range,
          });
        dispatch({
          type: this.eventsRetrieved,
          events: response,
        });
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  invalidateStore() {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch({ type: this.resetStore });
    };
  }
}

const signalConfigurationCRUDActions = new SignalConfigurationCRUDActions();

export default signalConfigurationCRUDActions;

export const useSignalConfigurationCRUDActions = getActionHookBuilder(
  signalConfigurationCRUDActions,
  ['getEvents', 'update', 'fetch', 'invalidateStore'],
);
